// eslint-disable-next-line no-restricted-imports
import { LegalClientBeneficiarySnapshotFragment } from 'api/generated/graphql';
import { LegalClientBeneficiarySnapshotEntity } from 'api/types/entity';
import { Maybe } from 'types/maybe';

import { parseLegalClientBeneficiaryEntity } from './parseLegalClientBeneficiaryEntity';

export const parseLegalClientBeneficiarySnapshotEntity = (
  data: Maybe<LegalClientBeneficiarySnapshotFragment>
): LegalClientBeneficiarySnapshotEntity | undefined =>
  data
    ? {
        createdAt: new Date(data.createdAt),
        id: data.id,
        value: parseLegalClientBeneficiaryEntity(data.value),
      }
    : undefined;
